// src/Seat.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Seat_default = createIcon({
  displayName: "Seat",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6 4C4.35503 4 3 5.35503 3 7V9.1875C1.84268 9.60487 1 10.7069 1 12V16C1 17.645 2.35503 19 4 19H5V21H7V19H17V21H19V19H20C21.645 19 23 17.645 23 16V12C23 10.7069 22.1573 9.60487 21 9.1875V7C21 5.35503 19.645 4 18 4H6ZM6 6H18C18.565 6 19 6.43497 19 7V9.1875C17.8427 9.60487 17 10.7069 17 12V13H7V12C7 10.7069 6.15732 9.60487 5 9.1875V7C5 6.43497 5.43497 6 6 6ZM4 11C4.56503 11 5 11.435 5 12V15H19V12C19 11.435 19.435 11 20 11C20.565 11 21 11.435 21 12V16C21 16.565 20.565 17 20 17H4C3.43497 17 3 16.565 3 16V12C3 11.435 3.43497 11 4 11Z",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Seat_default
};
